module.exports = __webpack_public_path__ + "media/images/weather/140_day-6862418c1f35194a6c0670f9068f657e.png";